import { ErrorPopup as BaseErrorPopup } from '../../baseComponents/ErrorPopup/ErrorPopup';
import { withReduxState } from '../Modal/ModalWithRedux';

export const ErrorPopup = withReduxState(BaseErrorPopup);
